import React from 'react';
import ReactPhoneNumberInput from 'react-phone-number-input';

import 'react-phone-number-input/style.css';

const PhoneInput = (props) => <ReactPhoneNumberInput {...props} />;

export default PhoneInput;
